import { connect, getIn } from 'formik';
import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';

import { Radio } from 'hb-react/shared/components/formik/components/inputs';

import Lifelong from '../Lifelong';
import Periodicity from '../Periodicity';

const Advanced = ({ formik, currency, periodicities }) => {
  const recurringEnabled =
    getIn(formik.values, 'donation_order[recurring_payment_enabled]') ===
    'true';

  return (
    <Box flexDirection="column" margin="auto" mb="30px" width="100%">
      <Radio
        name="donation_order[recurring_payment_enabled]"
        type="toggle"
        validate={{
          required: true,
        }}
        inputs={[
          {
            value: 'false',
            label: s__('Donations|Give once'),
          },
          {
            value: 'true',
            label: __('Recurring'),
          },
        ]}
        wrapperProps={{ mb: 0 }}
      />
      <Periodicity enabled={recurringEnabled} periodicities={periodicities} />
      <Lifelong enabled={recurringEnabled} currency={currency} />
    </Box>
  );
};

Advanced.propTypes = {
  currency: PropTypes.string.isRequired,
  periodicities: PropTypes.array.isRequired,
};

export default connect(Advanced);
